import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { SvgIconComponent } from 'angular-svg-icon';
import { BalanceIconComponent } from '@core/components/balance-icon/balance-icon.component';

@Component({
  selector: 'app-info-modal-max-payout',
  templateUrl: './info-modal-max-payout.component.html',
  styleUrl: './info-modal-max-payout.component.scss',
  standalone: true,
  imports: [DecimalPipe, SvgIconComponent, BalanceIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoModalMaxPayoutComponent {
  readonly maxPayout = input.required<number>();
}
